export default __webpack_public_path__ + "6be7a5b8a6982447f9c7cad84c3dda8f.svg";